import axios from 'axios'
import Requester from './Requester'

export const apiLimitReturned = 10

export const RequesterTradeInMethods = {
  GET_VEHICLE_BY_REGISTRATION: '/s-3/get-vehicule-by-immatriculation',
  GET_BRANDS: 'getMakes',
  GET_MODELS: 'getModels',
  GET_FINISHES: 'getTrims',
  GET_ENERGIES: 'getFuels',
  GET_FINISHES_ENERGIES: 'getTrimsFuels',
  GET_VERSIONS: 'getVersion',
  GET_PICTURES: 'getPictures',
  GET_EQUIPMENTS: 'getEquipments',
  GET_COLORS: 'getColors',
  GET_DESIGN: 'getDesign',
  GET_CAR_FROM_NUMBER_PLATE: 'getCarFromNumberPlate',
  GET_CAR_INFORMATIONS: 'getCarInformations',
  GET_PARAMS_FOR_DEFAULTS: 'getParamsForDefaults',
  GET_DAMAGES_ESTIMATED: 'getDamagesEstimated',
  GET_PARAMS_FOR_FINANCING_QUESTION: 'getParamsForFinancingQuestion',
  GET_PARAMS_FOR_TYRES_TYPE_QUESTION: 'getParamsForTyresTypeQuestion',
  GET_STORED_CONTEXT: 'getStoredContext',
  GET_REFERENCES_TRAILER_HITCHES: 'getReferencesTrailerHitches',
  GET_VATS: 'getVats'
}

/**
 * The Request class allows you to centralize calls to the outside of the application, including the server
 */
class RequesterTradeIn extends Requester {
  /**
   * Réalise des appels vers l'API
   *
   * @param {string} action le nom de l'action à réaliser
   * @param {*} params un objet de paramètres
   * @static
   * @return {Promise} une promesse en général avec les données de retour
   */
  static get = (action, params, redirectMessage) => {
    switch (action) {
      case RequesterTradeInMethods.GET_BRANDS: {
        const { date } = params

        return RequesterTradeIn.getRequest({
          urlApi: 'urlConfigurator',
          url: '/configurators/uc/makes',
          params: {
            putIntoService: date
          },
          redirectMessage
        })
      }
      case RequesterTradeInMethods.GET_MODELS: {
        const { date, makeId } = params

        return RequesterTradeIn.getRequest({
          urlApi: 'urlConfigurator',
          url: `/configurators/uc/makes/${makeId}/models`,
          params: {
            putIntoService: date
          },
          redirectMessage
        })
      }
      case RequesterTradeInMethods.GET_FINISHES: {
        const { date, makeId, modelId, fuelId } = params

        return RequesterTradeIn.getRequest({
          urlApi: 'urlConfigurator',
          url: `/configurators/uc/makes/${makeId}/models/${modelId}/trims`,
          params: {
            putIntoService: date,
            fuel: fuelId
          },
          redirectMessage
        })
      }
      case RequesterTradeInMethods.GET_ENERGIES: {
        const { date, makeId, modelId } = params

        return RequesterTradeIn.getRequest({
          urlApi: 'urlConfigurator',
          url: `/configurators/uc/makes/${makeId}/models/${modelId}/fuels`,
          params: {
            putIntoService: date
          },
          redirectMessage
        })
      }
      case RequesterTradeInMethods.GET_VERSIONS: {
        const { date, makeId, modelId, energyId, trim } = params

        return RequesterTradeIn.getRequest({
          urlApi: 'urlConfigurator',
          url: `/configurators/uc/makes/${makeId}/models/${modelId}/versions`,
          params: {
            putIntoService: date,
            fuels: energyId,
            trim
          },
          redirectMessage
        })
      }
      case RequesterTradeInMethods.GET_PARAMS_FOR_FINANCING_QUESTION: {
        return RequesterTradeIn.getRequest({
          urlApi: 'urlSelling',
          url: `/references/financing`,
          params: {},
          redirectMessage
        })
      }
      case RequesterTradeInMethods.GET_PARAMS_FOR_TYRES_TYPE_QUESTION: {
        return RequesterTradeIn.getRequest({
          urlApi: 'urlSelling',
          url: `/references/tyres-type`,
          params: {},
          redirectMessage
        })
      }
      case RequesterTradeInMethods.GET_PARAMS_FOR_DEFAULTS: {
        const requestPricingPolicy = RequesterTradeIn.getRequest({
          urlApi: 'urlScoring',
          url: `/pricing-policies/current/2`,
          params: {},
          redirectMessage
        })
        const requestReferences = RequesterTradeIn.getRequest({
          urlApi: 'urlSelling',
          url: `/references/damages-sections`,
          params: {},
          redirectMessage
        })
        const requestVats = RequesterTradeIn.getRequest({
          urlApi: 'urlIdentity',
          url: `/vats/current`,
          params: {},
          redirectMessage
        })
        const requests = [requestPricingPolicy, requestReferences, requestVats]
        return new Promise((resolve, reject) => {
          axios
            .all(requests)
            .then(
              axios.spread((pricingPolicyResponse, referencesResponse, vatsResponse) => {
                if (pricingPolicyResponse.error) {
                  if (pricingPolicyResponse.error.message)
                    reject(pricingPolicyResponse.error.message)

                  reject(pricingPolicyResponse.error)
                }
                if (referencesResponse.error) {
                  if (referencesResponse.error.message) reject(referencesResponse.error.message)

                  reject(referencesResponse.error)
                }
                if (vatsResponse.error) {
                  if (vatsResponse.error.message) reject(vatsResponse.error.message)

                  reject(vatsResponse.error)
                }

                const { items } = referencesResponse

                const response = {
                  pricingPolicyWs: pricingPolicyResponse.pricingPolicy,
                  sectionsWs: items,
                  vatsWs: vatsResponse.items.find(vat => vat.main)
                }

                resolve(response)
              })
            )
            .catch(error => {
              reject(error)
            })
        })
      }
      case RequesterTradeInMethods.GET_DAMAGES_ESTIMATED: {
        const { pricingPolicyId, estimatedDamageId, section, age, mileage } = params

        return RequesterTradeIn.getRequest({
          urlApi: 'urlScoring',
          url: `/pricing-policies/${pricingPolicyId}/estimated-damages/${estimatedDamageId}/sections/${section}/defects`,
          params: { age, mileage },
          redirectMessage
        })
      }
      case RequesterTradeInMethods.GET_PICTURES: {
        const { id } = params

        return RequesterTradeIn.getRequest({
          urlApi: 'urlConfigurator',
          url: `configurators/cars/${id}/pictures`,
          params: {},
          redirectMessage
        })
      }
      case RequesterTradeInMethods.GET_EQUIPMENTS: {
        const { id, catalog } = params

        return RequesterTradeIn.getRequest({
          urlApi: 'urlConfigurator',
          url: `/configurators/cars/${id}/equipments`,
          params: {
            group: true,
            catalog
          },
          redirectMessage
        })
      }
      case RequesterTradeInMethods.GET_DESIGN: {
        const { id, catalog } = params

        const requestSaddleries = RequesterTradeIn.getRequest({
          urlApi: 'urlConfigurator',
          url: `/configurators/cars/${id}/saddleries`,
          params: { catalog },
          redirectMessage
        })
        const requestPaints = RequesterTradeIn.getRequest({
          urlApi: 'urlConfigurator',
          url: `/configurators/cars/${id}/paints`,
          params: { catalog },
          redirectMessage
        })
        const requests = [requestSaddleries, requestPaints]
        return new Promise((resolve, reject) => {
          axios
            .all(requests)
            .then(
              axios.spread((saddleriesResponse, paintsResponse) => {
                if (saddleriesResponse.error) {
                  if (saddleriesResponse.error.message) reject(saddleriesResponse.error.message)

                  reject(saddleriesResponse.error)
                }
                if (paintsResponse.error) {
                  if (paintsResponse.error.message) reject(paintsResponse.error.message)

                  reject(paintsResponse.error)
                }

                const response = {
                  leathers: saddleriesResponse.leathers,
                  fabrics: saddleriesResponse.fabrics,
                  paints: paintsResponse.items
                }

                resolve(response)
              })
            )
            .catch(error => {
              reject(error)
            })
        })
      }
      case RequesterTradeInMethods.GET_COLORS: {
        const { makeId, modelId } = params

        return RequesterTradeIn.getRequest({
          urlApi: 'urlConfigurator',
          url: `/configurators/uc/makes/${makeId}/models/${modelId}/colors`,
          params: {},
          redirectMessage
        })
      }
      case RequesterTradeInMethods.GET_CAR_FROM_NUMBER_PLATE: {
        const { numberplate, vin, isVin } = params

        if (isVin) {
          return RequesterTradeIn.getRequest({
            urlApi: 'urlConfigurator',
            url: `/configurators/vin/${vin}`,
            params: {
              context: 2
            },
            redirectMessage
          })
        }
        return RequesterTradeIn.getRequest({
          urlApi: 'urlConfigurator',
          url: `/configurators/numberplate/${numberplate}`,
          params: {
            context: 2
          },
          redirectMessage
        })
      }
      case RequesterTradeInMethods.GET_CAR_INFORMATIONS: {
        const { id, catalog } = params

        return RequesterTradeIn.getRequest({
          urlApi: 'urlConfigurator',
          url: `/configurators/cars/${id}`,
          params: { catalog },
          redirectMessage
        })
      }
      case RequesterTradeInMethods.GET_FINISHES_ENERGIES: {
        const { date, makeId, modelId } = params

        const requestFinishes = RequesterTradeIn.getRequest({
          urlApi: 'urlConfigurator',
          url: `/configurators/uc/makes/${makeId}/models/${modelId}/trims`,
          params: {
            putIntoService: date
          },
          redirectMessage
        })
        const requestEnergies = RequesterTradeIn.getRequest({
          urlApi: 'urlConfigurator',
          url: `/configurators/uc/makes/${makeId}/models/${modelId}/fuels`,
          params: {
            putIntoService: date
          },
          redirectMessage
        })

        const requests = [requestFinishes, requestEnergies]
        return new Promise((resolve, reject) => {
          axios
            .all(requests)
            .then(
              axios.spread((finishesResponse, energiesResponse) => {
                if (finishesResponse.error) {
                  if (finishesResponse.error.message) reject(finishesResponse.error.message)

                  reject(finishesResponse.error)
                }
                if (energiesResponse.error) {
                  if (energiesResponse.error.message) reject(energiesResponse.error.message)

                  reject(energiesResponse.error)
                }

                const response = {
                  trims: finishesResponse.items,
                  energies: energiesResponse.items
                }
                resolve(response)
              })
            )
            .catch(error => {
              reject(error)
            })
        })
      }
      case RequesterTradeInMethods.GET_STORED_CONTEXT: {
        const { uuid } = params

        return RequesterTradeIn.getRequest({
          urlApi: 'urlLegacy',
          url: `/campaigns/current/contexts/${uuid}`,
          redirectMessage
        })
      }
      case RequesterTradeInMethods.GET_VATS: {
        return RequesterTradeIn.getRequest({
          urlApi: 'urlIdentity',
          url: `/vats/current`,
          params: {},
          redirectMessage
        })
      }
      case RequesterTradeInMethods.GET_REFERENCES_TRAILER_HITCHES: {
        return RequesterTradeIn.getRequest({
          urlApi: 'urlSelling',
          url: `/references/trailer-hitches`,
          params: {},
          redirectMessage
        })
      }
      default:
        return null
    }
  }
}

export default RequesterTradeIn
